<template>
  <div class="tag-list-left">
    <!--    <van-sticky class="tag-list-left_menu" :container="$el">-->
    <van-sidebar
      v-model="currentTagIndex"
      :style="sideStyle"
      ref="side"
      @change="onChange"
    >
      <van-sidebar-item
        :title="item.category_tag_name"
        :name="item.key"
        v-for="item in configList"
        :key="item.key"
      />
    </van-sidebar>
    <!--    </van-sticky>-->
    <div class="vertical-goods-list">
      <div
        class="cate-block"
        v-for="(item, index) in configList"
        :key="item.key"
        ref="goods"
      >
        <h3 class="cate-title">
          <span>{{ item.category_tag_name }}</span>
          <span v-if="item.show_all_btn">
            <i>查看更多</i>
            <van-icon name="arrow" />
          </span>
        </h3>
        <Goods
          :config="item"
          :preview="preview"
          @height-change="getOffsetList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Goods from "../Goods";

export default {
  name: "TagListLeft",
  props: {
    configList: Array,
    preview: Boolean,
    top: Number
  },
  components: { Goods },
  data() {
    return {
      sideHeight: 667,
      offsetList: [],
      height: 667,
      currentTagIndex: 0
    };
  },
  created() {},
  mounted() {
    this.watchTop = true;
    this.$nextTick(() => {
      this.sideHeight = this.$refs["side"].$el.clientHeight;
      this.getOffsetList();
    });
  },
  methods: {
    getOffsetList() {
      this.offsetList = this.$refs["goods"].reduce(
        (pre, it) => [...pre, (pre.slice(-1)[0] || 0) + it.clientHeight],
        [0]
      );
      this.height = this.$el.clientHeight;
    },
    onChange(v) {
      this.watchTop = false;
      setTimeout(() => {
        this.watchTop = true;
      }, 800);
      const offsetTop = this.$el.offsetTop;
      console.log(
        "index ",
        v,
        "scroll to ",
        this.offsetList[v],
        offsetTop,
        this.offsetList[v] + offsetTop,
        [...this.offsetList]
      );
      document.scrollingElement.scrollTop = this.offsetList[v] + offsetTop;
    }
  },
  computed: {
    sideStyle() {
      if (this.top > 0)
        return {
          position: "absolute",
          top: "0"
        };
      if (this.top < this.sideHeight - this.height)
        return {
          position: "absolute",
          bottom: "0"
        };
      return {
        position: "fixed",
        top: "0"
      };
    }
    /*	  currentTagIndex: {
              get() {
                if (this.top > 0) return 0;
                return this.offsetList.findIndex(it => (it + this.top) > 0) - 1;
              },
              set(v) {
                document.documentElement.scrollTop = this.offsetList[v] + this.scrollTop;
              },
            }*/
  },
  watch: {
    "sideStyle.position"(now) {
      // 左侧菜单固定状态变化时,广播
      if (now === "absolute") {
        this.$pub.$emit("goods-tag-list-leave");
      }
      if (now === "fixed") {
        this.$pub.$emit("goods-tag-list-enter");
      }
    },
    top() {
      if (this.top > 0) return;
      if (!this.watchTop) return;
      this.currentTagIndex =
        this.offsetList.findIndex(it => it + this.top > 0) - 1;
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less">
.tag-list-left {
  position: relative;

  .van-sidebar {
    max-height: 100vh;
    position: absolute;
    left: 0;
  }

  .tag-list-left_menu {
    background-color: #fff;
    position: absolute;
    bottom: 0;
    top: 0;
    left: 0;
    width: 85px;
  }

  .vertical-goods-list {
    padding-left: 85px;
    background-color: #fff;

    .cate-title {
      padding: 0 10px;
      height: 40px;
      font-size: 12px;
      color: @text-color-gray;
      display: flex;
      align-items: center;
      justify-content: space-between;
      i {
        font-style: normal;
      }
    }
  }
}
</style>
